// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { createTheme } from '@mui/material';
import digitalAssetLogo from '../assets/digitalAssetLogo.png';
import TextLogo from '../components/TextLogo';
import { Branding } from '../utils/branding';
import baseline from './baseline';

const portfolio: Branding = {
  loginLogo: <TextLogo size="large" text="Canton Network Portfolio" />,
  headerLogo: <TextLogo size="medium" text="Canton Network Portfolio" />,
  companyLogo: (
    <img alt="" src={digitalAssetLogo} height="18px" style={{ display: 'inline-block' }} />
  ),
};

export default { branding: portfolio, theme: createTheme(baseline) };
